
const { mapState } = require('vuex')

export default {
  data: () => ({
    navContext: {
      drawer: false
    }
  }),
  head () {
    const scrollMode = this.$route.name === 'application-id-config' ? 'hidden' : 'scroll'
    return {
      htmlAttrs: { lang: this.$i18n.locale }, // TODO: this should be set by nuxt-i18n but it isn't for some reason
      style: [{ vmid: 'dynamic-style', cssText: this.$store.getters.style(scrollMode), type: 'text/css' }],
      __dangerouslyDisableSanitizers: ['style']
    }
  },
  computed: {
    ...mapState(['env']),
    isMainDomain () {
      return this.env.mainPublicUrl.startsWith(window.location.origin)
    }
  },
  mounted () {
    if (!this.$vuetify.breakpoint.mobile) this.navContext.drawer = true
  }
}

